import { useTranslation } from 'react-i18next'

import { formatDate, formatDateTime } from '../lib/dateFormat'
import { trailWhen } from '../lib/trailEntry'

export default function TrailTime({
  entry,
  className = '',
}: {
  entry: { at: string; action: string; actor_kind: string; actor_name: string }
  className?: string
}) {
  const { t, i18n } = useTranslation()
  const when = trailWhen(entry)
  return (
    <span className={`tabular-nums ${className}`}>
      {when.kind === 'exact'
        ? formatDateTime(when.at, i18n.language)
        : t('audit.documentTrail.onRecordBy', { date: formatDate(when.at, i18n.language) })}
    </span>
  )
}
